import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-start md:items-center pt-28 md:pt-20">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://public.readdy.ai/ai/img_res/5fa273f046719e9607e187f9df52a8e2.jpg"
            alt="Hero Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6">
          <div className="flex flex-col items-center gap-8">
            <div className="w-full text-center text-white">
              <div className="flex items-center justify-center mb-6">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-flower-line text-3xl text-white/90"></i>
                </div>
              </div>
              
              <h1 className="text-3xl md:text-6xl font-serif leading-relaxed mb-4 md:mb-8 drop-shadow-lg">
                医師の隣にいる女が<br />
                あなたの医師恋を加速させる
              </h1>
              
              <p className="text-xl md:text-4xl font-light italic mb-3 md:mb-6 text-white/95 drop-shadow-md">
                医師と出会いたいけど<br />
                恋がはじまらない。
              </p>
              
              <p className="text-lg md:text-3xl mb-6 md:mb-6 text-white/90 drop-shadow-md">
                そういう人のためのカウンセリングサービスです。
              </p>

              <div className="flex justify-center">
                <Link
                  to="/booking"
                  className="inline-block bg-[#C9A0A0] text-white px-10 md:px-14 py-4 md:py-5 rounded-full text-base md:text-lg font-medium hover:bg-[#B88B8B] transition-all shadow-xl whitespace-nowrap cursor-pointer"
                >
                  カウンセリングを予約する
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-20 left-10 opacity-30 z-10 hidden md:block">
          <div className="w-16 h-16 flex items-center justify-center">
            <i className="ri-flower-line text-5xl text-white"></i>
          </div>
        </div>
        <div className="absolute bottom-20 right-10 opacity-30 z-10 hidden md:block">
          <div className="w-16 h-16 flex items-center justify-center">
            <i className="ri-flower-line text-5xl text-white"></i>
          </div>
        </div>
      </section>

      {/* Target Audience Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-serif mb-6 text-[#2C2C2C]">
              思い当たることは、<br className="md:hidden" />ありますか。
            </h2>
            <div className="w-32 h-px bg-[#D4A5A5] mx-auto"></div>
          </div>

          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-start gap-4 md:gap-6">
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-flower-line text-xl md:text-2xl text-[#D4A5A5]"></i>
                </div>
                <p className="text-base md:text-xl leading-loose text-[#4A4A4A]">
                  医師とマッチングしても、3往復で話題が尽きる。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-start gap-4 md:gap-6">
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-flower-line text-xl md:text-2xl text-[#D4A5A5]"></i>
                </div>
                <p className="text-base md:text-xl leading-loose text-[#4A4A4A]">
                  何を話せばいいかわからなくて、当たり障りのない返事をしてしまう。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-start gap-4 md:gap-6">
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-flower-line text-xl md:text-2xl text-[#D4A5A5]"></i>
                </div>
                <p className="text-base md:text-xl leading-loose text-[#4A4A4A]">
                  気を遣いすぎて、気づいたらフェードアウトされている。
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <p className="text-xl md:text-3xl font-serif italic text-[#888888]">
              チャンスはあった。<br />
              ただ、準備ができていなかった。
            </p>
          </div>
        </div>
      </section>

      {/* Service Description Section */}
      <section className="py-16 md:py-24 bg-[#FFF8F5]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16">
            {/* Text Content */}
            <div className="w-full md:flex-1">
              <h2 className="text-2xl md:text-4xl font-serif font-bold mb-8 md:mb-10 text-[#2C2C2C]">
                Dr.Catchは、練習する場所
              </h2>

              <div className="space-y-6 md:space-y-8">
                <div className="flex items-start gap-4">
                  <span className="text-2xl md:text-3xl font-serif text-[#D4A5A5] flex-shrink-0">①</span>
                  <p className="text-base md:text-2xl leading-loose text-[#4A4A4A] pt-1">
                    まず、あなたの状況を丁寧に聞きます。どんな相手と、どんな場面で、何に困っているのかを整理します。
                  </p>
                </div>

                <div className="flex items-start gap-4">
                  <span className="text-2xl md:text-3xl font-serif text-[#D4A5A5] flex-shrink-0">②</span>
                  <p className="text-base md:text-2xl leading-loose text-[#4A4A4A] pt-1">
                    対話のロールプレイを行います。医師のコミュニケーションを知り尽くしたカウンセラーが対応します。
                  </p>
                </div>

                <div className="flex items-start gap-4">
                  <span className="text-2xl md:text-3xl font-serif text-[#D4A5A5] flex-shrink-0">③</span>
                  <p className="text-base md:text-2xl leading-loose text-[#4A4A4A] pt-1">
                    セッション後、気づいたことをフィードバックします。あなたの言葉の癖や、相手への伝わり方を一緒に確認します。
                  </p>
                </div>
              </div>

              <div className="mt-10 pt-6 border-t-2 border-[#E8D5D5]">
                <p className="text-base md:text-2xl leading-loose text-[#4A4A4A]">
                  アドバイスだけなら、本で足ります。
                </p>
                <p className="text-xl md:text-3xl font-bold mt-3 text-[#2C2C2C]">
                  このサービスは「体験」です。
                </p>
              </div>
            </div>

            {/* Image */}
            <div className="w-full md:flex-1">
              <div className="relative">
                <div className="absolute -inset-4 border-2 border-[#E8D5D5] rounded-3xl opacity-50"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=elegant%20watercolor%20illustration%20of%20delicate%20flowers%20and%20botanical%20elements%2C%20soft%20pink%20roses%20and%20cherry%20blossoms%20with%20green%20leaves%2C%20dreamy%20pastel%20color%20palette%20with%20cream%20and%20blush%20tones%2C%20artistic%20and%20feminine%20style%2C%20gentle%20flowing%20composition%2C%20sophisticated%20Japanese%20aesthetic%2C%20peaceful%20and%20romantic%20mood%2C%20high%20quality%20artistic%20rendering&width=600&height=700&seq=drcatch-service-illustration-001&orientation=portrait"
                  alt="サービスイメージ"
                  className="relative z-10 w-full rounded-3xl shadow-xl object-cover"
                  style={{ height: '400px' }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Credentials Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-serif mb-6 text-[#2C2C2C]">カウンセラー</h2>
            <div className="w-32 h-px bg-[#D4A5A5] mx-auto"></div>
          </div>

          <div className="flex flex-col md:flex-row items-start gap-8 md:gap-12">
            {/* Photo */}
            <div className="flex-shrink-0 flex flex-col items-center gap-4 w-full md:w-auto">
              <div className="w-44 h-44 md:w-52 md:h-52 rounded-full overflow-hidden shadow-xl border-4 border-[#F5E8E4]">
                <img
                  src="https://static.readdy.ai/image/d4208e7c1b6fcc1a247dec5c1658bdd1/c902a90259f3aac8096473bc195c4b03.png"
                  alt="ジェイゾロフト瞳"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <p className="text-lg font-serif font-bold text-[#2C2C2C] text-center">ジェイゾロフト瞳</p>
              <p className="text-sm text-[#C9A0A0] tracking-widest text-center">Hitomi Zoloft J.</p>
            </div>

            {/* Text */}
            <div className="relative flex-1">
              <div className="absolute -right-12 bottom-0 opacity-20 hidden lg:block">
                <div className="w-24 h-24 flex items-center justify-center">
                  <i className="ri-flower-line text-7xl text-[#D4A5A5]"></i>
                </div>
              </div>

              <div className="space-y-5 text-base md:text-xl leading-loose text-[#4A4A4A]">
                <p>
                  障害者・バツイチながらマッチングアプリで多数の医師・経営者と話し、独自の対話スキルで多くの医師から交際を申し込まれました。
                </p>

                <p>
                  企業広報、作家として200件以上のインタビューを経験。対話のプロフェッショナルです。
                </p>

                <p>
                  現在も医師と交際しております。<br />
                  医師という職業の人間がどのように話し、どういうふうに黙るかを知り尽くしています。
                </p>

                <p className="text-lg md:text-2xl font-bold text-[#2C2C2C]">
                  そのジェイゾロフト瞳が、<br />
                  直接あなたにアプローチします。
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/profile"
              className="inline-flex items-center gap-2 text-[#C9A0A0] hover:text-[#B88B8B] transition-colors text-base md:text-lg cursor-pointer"
            >
              詳しいプロフィールを見る
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 md:py-32 bg-gradient-to-br from-[#F5E8E4] to-[#E8D5D5] relative overflow-hidden">
        {/* Decorative Flowers */}
        <div className="absolute top-10 left-10 opacity-20 hidden md:block">
          <div className="w-32 h-32 flex items-center justify-center">
            <i className="ri-flower-line text-8xl text-[#C9A0A0]"></i>
          </div>
        </div>
        <div className="absolute top-10 right-10 opacity-20 hidden md:block">
          <div className="w-32 h-32 flex items-center justify-center">
            <i className="ri-flower-line text-8xl text-[#C9A0A0]"></i>
          </div>
        </div>
        <div className="absolute bottom-10 left-10 opacity-20 hidden md:block">
          <div className="w-32 h-32 flex items-center justify-center">
            <i className="ri-flower-line text-8xl text-[#C9A0A0]"></i>
          </div>
        </div>
        <div className="absolute bottom-10 right-10 opacity-20 hidden md:block">
          <div className="w-32 h-32 flex items-center justify-center">
            <i className="ri-flower-line text-8xl text-[#C9A0A0]"></i>
          </div>
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 md:mb-10 text-[#2C2C2C] leading-relaxed">
            本番前に、ここで<br className="md:hidden" />負けてください。
          </h2>

          <p className="text-lg md:text-3xl leading-loose text-[#4A4A4A] mb-3 md:mb-4">
            相手が医師であることは、ハンデではありません。
          </p>
          <p className="text-lg md:text-3xl leading-loose text-[#4A4A4A] mb-10 md:mb-16">
            知らないだけです。
          </p>

          <div className="flex justify-center">
            <Link
              to="/booking"
              className="inline-block bg-[#B88B8B] text-white px-10 md:px-16 py-4 md:py-6 rounded-full text-base md:text-xl font-medium hover:bg-[#A67A7A] transition-all shadow-xl whitespace-nowrap cursor-pointer"
            >
              カウンセリングを予約する
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}